module.exports = __webpack_public_path__ + "img/orsal.dc598823.png";